export default function () {
  return [
    { key: 'firstName' }, { key: 'lastName' }, { key: 'username' }, { key: 'phone' }, { key: 'email' },
    {
      key: 'orgIds',
      type: 'org',
      props: {
        clearable: true,
        multiple: true
      }
    },
    {
      key: 'buIds',
      label: 'businessUnit',
      type: 'bu',
      props: {
        clearable: true,
        multiple: true
      }
    },
    {key:"roleId", label:"role"}

  ]
}
